module.exports = [{
      plugin: require('C:/Donatello/work/1b39dd3690dc639/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Snjallheimili Nova","short_name":"Snjallheimilið","start_url":"/","background_color":"#fe3c72","theme_color":"#fe3c72","display":"minimal-ui","icon":"src/assets/images/favicon.png"},
    },{
      plugin: require('C:/Donatello/work/1b39dd3690dc639/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"C:\\Donatello\\work\\1b39dd3690dc639\\src\\components\\app-layout\\AppLayout.tsx"},
    },{
      plugin: require('C:/Donatello/work/1b39dd3690dc639/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NT22KVH"},
    },{
      plugin: require('C:/Donatello/work/1b39dd3690dc639/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
